import { Power2, TweenMax } from 'gsap';
import $ from 'jquery';
import ThingsManagerClass from '../../libs/base/ThingsManagerClass';
import Util from '../../libs/util/Util';

/**
 * 検索枠で使用されるモーダルの基礎クラス
 */
export default class PickModalClass extends ThingsManagerClass {
  constructor(_id) {
    super();
    this.name = 'PickModalClass';

    this.CL_MODAL_OPEN = 'isModalOpen';

    this.EVENT_BEFORE_NEGATIVE = 'eventBeforeNegative';
    this.EVENT_BEFORE_POSITIVE = 'eventBeforePositive';

    this.EVENT_NEGATIVE = 'eventNegative';
    this.EVENT_POSITIVE = 'eventPositive';

    this.id = _id;

    this.onClickModalToggleListener = this.onClickModalToggle.bind(this);

    this.isOpen = false;

    this.baseHorizontal = true;// 左寄り

    this.isAnimation = false;
    this.selector = null;
    this.isCloseBlock = false;
  }

  onCreate() {
    super.onCreate();

    this.selector = '.js-pick_modal[data-target=' + this.id + '],.pick_modal[data-id=' + this.id + ']';

    this.clickTarget = $('.js-pick_modal[data-target=' + this.id + ']');
    this.modal = $('.pick_modal[data-id=' + this.id + ']');
    // console.log(this.id,this.name,this.modal,this.clickTarget);

    this.baseHorizontal = !(this.modal.attr('data-base_position_h') === 'right');

    this.clickTarget.on('click', this.onClickModalToggleListener);

    $(document).on('click', (e) => {
      // if(this.isOpen) console.log(this.name,"isCloseBlock check:",this.isCloseBlock);
      if ((!$(e.target).closest(this.selector).length && !this.isCloseBlock) && this.isOpen) {
        this.onClose(this.EVENT_NEGATIVE);
      }
      if (this.isOpen && this.isCloseBlock) {
        this.isCloseBlock = false;
      }
    });

    $('.positive', this.modal).on('click', (e) => {
      e.preventDefault();
      this.onClose(this.EVENT_POSITIVE);
    });

    $('.negative', this.modal).on('click', (e) => {
      e.preventDefault();
      this.onClose(this.EVENT_NEGATIVE);
    });

    $('.header .close', this.modal).on('click', (e) => {
      e.preventDefault();
      this.onClose(this.EVENT_NEGATIVE);
    });
  }

  onResize(_size) {
    super.onResize(_size);

    if (Util.isBreakpoint) { return; }

    let offset = this.clickTarget.not(':hidden').offset();
    // console.log(this.name,offset);
    let position;
    if (!offset) {
      let top = (_size.h - this.modal.height()) / 2;
      let left = (_size.w - this.modal.width()) / 2;
      // console.log(this.name,"onResize",left);
      // console.log(this.modal.width(),this.modal.height());
      top += Util.getScrollY();
      position = { top: top, left: left };
    } else {
      // console.log(this.name,"onResize",offset.left,this.modal.width(),);
      let left = offset.left;
      let mleft = parseFloat(this.modal.css('margin-left')) * -1;
      let diff = left - mleft;
      if (diff < 0) {
        left -= diff - 40;
      }
      // console.log(left,mleft,diff);
      position = { top: offset.top, left: left };
    }
    if (!this.baseHorizontal) {
      // 右寄り
      position.left = 'auto';
      position.right = _size.w - (offset.left + this.clickTarget.outerWidth(true));
    }

    this.modal.css(position);
  }

  onClickModalToggle(e) {
    e.preventDefault();

    if (this.isOpen) {
      this.onClose(this.EVENT_NEGATIVE);
    } else {
      this.onOpen();
    }
  }

  onClose(_event) {
    if (this.isAnimation || !this.isOpen) { return; }
    this.isOpen = false;

    if (_event === this.EVENT_NEGATIVE) {
      this.onNegativeBefore();
      this.jq.trigger(this.EVENT_BEFORE_NEGATIVE);
    } else {
      this.onPositiveBefore();
      this.jq.trigger(this.EVENT_BEFORE_POSITIVE);
    }

    $('html').removeClass(this.CL_MODAL_OPEN);
    Util.isSpModalOpen = false;
    if (Util.isBreakpoint) { $('html,body').scrollTop(this.scrollTop); }

    this.onCloseBefore();

    const time = 0.3;
    const ease = Power2.easeOut;
    TweenMax.killTweensOf(this.modal);
    let y = 0;
    if (Util.isBreakpoint) { y = '100%'; }
    // console.log(this.name,"onClose before");
    TweenMax.to(this.modal, time, {
      opacity: 0, y: y, ease: ease, onComplete: () => {
        this.modal.css({ display: '' });
        if (_event === this.EVENT_NEGATIVE) {
          this.onNegative();
        } else {
          this.onPositive();
        }
        if (_event) { this.jq.trigger(_event); }
        // console.log(this.name,"onClose after",_event);

        this.isAnimation = false;
        this.onCloseAfter();
      },
    });
  }

  onCloseBefore() { }
  onCloseAfter() { }

  onOpen() {
    if (this.isAnimation || this.isOpen) { return; }
    // console.log(this.name,"onOpen",this.modal);
    this.scrollTop = Util.getScrollY();
    this.isOpen = true;
    const time = 0.3;
    const ease = Power2.easeOut;
    TweenMax.killTweensOf(this.modal);

    this.modal.css({ display: 'block' });
    $(window).trigger('resize');
    if (Util.isBreakpoint) { TweenMax.set(this.modal, { y: '100%' }); }
    this.onOpenBefore();
    TweenMax.to(this.modal, time, {
      opacity: 1, y: '0%', ease: ease, onComplete: () => {
        this.isAnimation = false;
        $('html').addClass(this.CL_MODAL_OPEN);
        Util.isSpModalOpen = true;
        this.modal.css({ transform: '' });
        if (Util.isBreakpoint) {
          $('html,body').scrollTop(0);
          $(window).trigger('resize');
        }
        this.onOpenAfter();
      },
    });
  }

  onOpenBefore() { }
  onOpenAfter() { }

  onSetClickTargetText(_text) {
    $('.text', this.clickTarget).text(_text);
  }

  onPositive() { }
  onPositiveBefore() { }
  onNegative() { }
  onNegativeBefore() { }
}
